import React, { useState } from 'react';
import { Tabs, Flex, Card, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import DataExportList from './DataExportList';
import DataImportList from './DataImportList';
import { DatabaseOutlined, UploadOutlined, DownloadOutlined } from '@ant-design/icons';

const DataExportImportPage = () => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState('exports');

    const items = [
        {
            key: 'exports',
            label: (
                <Space size={8}>
                    <DownloadOutlined style={{ fontSize: '16px' }} />
                    <span style={{ fontWeight: 500 }}>{t('exports')}</span>
                </Space>
            ),
        },
        {
            key: 'imports',
            label: (
                <Space size={8}>
                    <UploadOutlined style={{ fontSize: '16px' }} />
                    <span style={{ fontWeight: 500 }}>{t('imports')}</span>
                </Space>
            ),
        },
    ];

    return (
        <Flex vertical style={{ height: '100%', padding: 0 }} gap="middle">
            <Card style={{ boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)' }} size='small' styles={{ body: { padding: '0 21px' } }}>
                <Tabs
                    activeKey={activeTab}
                    onChange={setActiveTab}
                    items={items}
                />
            </Card>
            {activeTab === 'exports' && <DataExportList />}
            {activeTab === 'imports' && <DataImportList />}
        </Flex>
    );
};

export default DataExportImportPage;
